// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wa_a bht_b"};